import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["submitButton"]

    connect() {
        this.updateButton()
    }

    // ------------------------------------------------------------
    // Enable button when form valid
    // ------------------------------------------------------------

    updateButton() {
        if (!this.hasSubmitButtonTarget) return

        const form = this.element.querySelector("form")
        if (!form) return

        const amount = parseFloat(
            form.querySelector("[name='transfer[amount]']")?.value || 0
        )

        const date = form.querySelector("[name='transfer[transfer_date]']")
        const fromAccount = form.querySelector("[name='transfer[from_bank_account_id]']")
        const toAccount = form.querySelector("[name='transfer[to_bank_account_id]']")

        const valid =
            amount > 0 &&
            date?.value &&
            fromAccount?.value &&
            toAccount?.value

        this.submitButtonTarget.disabled = !valid
    }

    // ------------------------------------------------------------
    // Add virtual Transfer match
    // ------------------------------------------------------------

    addMatch(event) {
        console.log("addMatch", event)
        event.preventDefault()

        const form = this.element.querySelector("form")
        if (!form) return

        const amount = parseFloat(
            form.querySelector("[name='transfer[amount]']")?.value || 0
        )

        const reference =
            form.querySelector("[name='transfer[reference]']")?.value || ""

        const fromAccountSelect = form.querySelector(
            "[name='transfer[from_bank_account_id]']"
        )

        const toAccountSelect = form.querySelector(
            "[name='transfer[to_bank_account_id]']"
        )

        const fromName =
            fromAccountSelect?.selectedOptions?.[0]?.text || ""

        const toName =
            toAccountSelect?.selectedOptions?.[0]?.text || ""

        const item = {
            type: "Finance::Transfer",
            id: `transfer-${Date.now()}`,
            title: "Transfer",
            subtitle: `${fromName} → ${toName}`,
            amount: amount,
            payload: this.serializeForm(form)
        }

        this.resetForm(form)

        this.dispatch("add", {
            detail: item
        })
    }

    // ------------------------------------------------------------
    // Serialize form data
    // ------------------------------------------------------------

    serializeForm(form) {
        return {
            to_bank_account_id: form.querySelector("[name='transfer[to_bank_account_id]']")?.value,
            from_bank_account_id: form.querySelector("[name='transfer[from_bank_account_id]']")?.value,
            transfer_date: form.querySelector("[name='transfer[transfer_date]']")?.value,
            amount: parseFloat(form.querySelector("[name='transfer[amount]']")?.value || 0),
            reference: form.querySelector("[name='transfer[reference]']")?.value || ""
        }
    }

    // ------------------------------------------------------------
    // Reset form to original state
    // ------------------------------------------------------------

    resetForm(form) {
        form.reset()

        // Keep amount as remaining (reconciliation controller sets it)
        const amountField = form.querySelector("[name='transfer[amount]']")
        if (amountField) amountField.dispatchEvent(new Event("input"))

        this.updateButton()
    }
}
